import { render, staticRenderFns } from "./SrvModal.vue?vue&type=template&id=27d0a390&"
import script from "./SrvModal.vue?vue&type=script&lang=js&"
export * from "./SrvModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../whitelabel/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports